import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import NewsAndInsights from "./NewsAndInsights";
import Section from "./Section";
import FaqAccordion from "../componentsSections/FaqAccordion";
import RequestDemoBanner from "../componentsSections/RequestDemoBanner";

const hasFaqItemContent = (item) =>
    item?.question?.trim() && item?.answer?.trim();

const hasFaqContent = (data) => data?.items?.some(hasFaqItemContent);

const PageFooterSections = ({
    pageData,
    faqData,
    hideFaq = false,
    hideRequestDemo = false,
    hideNews = false,
}) => {
    const data = useStaticQuery(graphql`
        query PageFooterSectionsQuery {
            wp {
                mdaThemeOptions {
                    themeSettings {
                        requestDemoBanner {
                            header
                            description
                            button {
                                target
                                title
                                url
                            }
                        }
                    }
                }
            }
        }
    `);

    const globalSettings = data?.wp?.mdaThemeOptions?.themeSettings;
    const resolvedFaqData = hasFaqContent(pageData?.faqSection)
        ? pageData.faqSection
        : hasFaqContent(faqData)
        ? faqData
        : null;
    const filteredFaqData = resolvedFaqData
        ? {
              ...resolvedFaqData,
              items: resolvedFaqData.items.filter(hasFaqItemContent),
          }
        : null;
    const resolvedRequestDemoBannerData = globalSettings?.requestDemoBanner;

    return (
        <>
            {!hideRequestDemo && (
                <Section className="-margin-bottom-tiny -mobile-full">
                    <RequestDemoBanner
                        {...resolvedRequestDemoBannerData}
                        icon={resolvedRequestDemoBannerData?.icon}
                    />
                </Section>
            )}

            {!hideFaq && hasFaqContent(filteredFaqData) && (
                <Section className="-mobile-full">
                    <FaqAccordion {...filteredFaqData} />
                </Section>
            )}

            {!hideNews && (
                <Section className="-mobile-full">
                    <NewsAndInsights />
                </Section>
            )}
        </>
    );
};

export default PageFooterSections;
